import { SearchOutline24Icon } from "@vygruppen/spor-icon-react";
import { Combobox, Item, ItemLabel } from "shared/components/Spor";
import { StyleTarget } from "shared/components/StyleTarget";
import { css } from "styled-components";

interface SearchableItem {
  setId?: string;
  name?: string;
}

interface SearchComboboxProps {
  searchQuery: string;
  onInputChange: (value: string) => void;
  searchable: SearchableItem[];
  isLoading: boolean;
}

export const SearchCombobox = ({
  searchQuery,
  onInputChange,
  searchable,
  isLoading,
}: SearchComboboxProps) => (
  <StyleTarget
    $style={css`
      /* Enough space to show 'Søk etter kjøretøy eller ansatt' */
      width: 30%;

      /* 1000px is just before it would naturally flex-wrap */
      @container (width < 1000px) {
        width: 100%;
      }
    `}
    $target="&&&"
  >
    <Combobox
      autoFocus
      label="Søk etter kjøretøy eller ansatt"
      inputValue={searchQuery}
      onInputChange={onInputChange}
      leftIcon={<SearchOutline24Icon />}
      placeholder="Søk etter kjøretøy eller ansatt"
      loading={isLoading}
      allowsCustomValue
    >
      {searchable &&
      Array.isArray(searchable || []) &&
      searchable.length > 0 ? (
        searchable.map((variant) =>
          "setId" in variant ? (
            <Item key={variant.setId} textValue={variant.setId}>
              <ItemLabel>{variant.setId}</ItemLabel>
            </Item>
          ) : (
            <Item key={variant.name} textValue={variant.name}>
              <ItemLabel>{variant.name}</ItemLabel>
            </Item>
          ),
        )
      ) : (
        <Item textValue="Ingen kjøretøy tilgjengelig">
          <ItemLabel>Ingen kjøretøy tilgjengelig</ItemLabel>
        </Item>
      )}
    </Combobox>
  </StyleTarget>
);
